import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { ToastMessageModel } from './toast-message.model';

@Injectable()
export class ToastMessageService {
  constructor() {}
  messageId = 0;
  private alertEvent: Subject<ToastMessageModel> = new Subject();

  getAlertEvent() {
    return this.alertEvent.asObservable();
  }

  showSucccess(message: string, customTimeout?: number) {
    this.showToast('success', message, customTimeout);
  }

  showInfo(message: string, customTimeout?: number) {
    this.showToast('info', message, customTimeout);
  }

  showWarning(message: string, customTimeout?: number) {
    this.showToast('warning', message, customTimeout);
  }

  showError(message: string, customTimeout?: number) {
    this.showToast('danger', message, customTimeout);
  }

  showToast(level: string, message: string, customTimeout?: number) {
    const toast: ToastMessageModel = {
      id: this.messageId++,
      type: level,
      message: message,
    };
    if (customTimeout === 0) {
      toast.isSticky = true;
    } else {
      toast.customTimeout = customTimeout;
    }
    this.alertEvent.next(toast);
  }
}
